import ClientAuth from '@/components/ClientAuth';
import { useAuth, useOauth } from '@/contexts/AuthContext';
import { buildOAuthSuccessLoginRedirectUrl } from '@/utils/oauthSuccessRedirect';
import React, { useEffect } from 'react';

const OAuthSuccessPage: React.FC = () => {
    const { user, isLoadingProfile } = useAuth();
    const { getOAuthContextFromSearch, clearOAuthContext } = useOauth();
    const oauthContext = getOAuthContextFromSearch(window.location.search);

    useEffect(() => {
        if (isLoadingProfile || user) {
            return;
        }

        window.location.replace(buildOAuthSuccessLoginRedirectUrl(window.location.search));
    }, [isLoadingProfile, user]);

    useEffect(() => {
        if (oauthContext) {
            return;
        }

        clearOAuthContext();
        if (!user) {
            return;
        }

        window.location.href = '/admin';
    }, [clearOAuthContext, oauthContext, user]);

    if (isLoadingProfile || !user || !oauthContext) {
        return null;
    }

    return <ClientAuth mode="oauth" oauthContext={oauthContext} />;
};

export default OAuthSuccessPage;
